export const CHART_OPERATIONS = {
  ZOOM_COMPLETED: 'zoomCompleted',
  ZOOM_IN: 'zoomIn',
  ZOOM_OUT: 'zoomOut',
  CLICK: 'clickMapObject',
  LABEL_FORMAT: '0.0a',
  LABEL_SHAPE: 'circle',
};

export enum CHART_TYPES {
  MAPKPI = 'mapKpi',
  BAR_VERTICAL = 'bar-vertical',
  BAR_HORIZONTAL = 'bar-horizontal',
  BAR_VERTICAL_STACKED = 'bar-vertical-stacked',
  BAR_HORIZONTAL_STACKED = 'bar-horizontal-stacked',
  BAR_WITH_LINE = 'bar-with-line',
  LINE = 'line',
  PIE = 'pie',
  RADAR = 'radar',
  TREEMAP = 'treemap',
  FUNNEL = 'funnel',
  BAR = 'bar',
}
